
export function websocketErrorHandleInterceptor(
	socket: WebSocket,
	onUnauthorized: (code: number) => void
): boolean {

	socket.onerror = () => {
		onUnauthorized(909090);
		return false;
	};

	socket.onclose = (event) => {
		if (event.code !== 1000) {
			onUnauthorized(event.code);
		}
		return false;
	};

	return true;
}